document.addEventListener("DOMContentLoaded", function () {
  const parentItems = document.querySelectorAll('.navmenu-item-parent');
  
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  function handleSubmenuPosition(item) {
    const submenu = item.querySelector('.navmenu-submenu');
    if (!submenu) return;

    const clone = submenu.cloneNode(true);
    clone.style.position = 'absolute';
    clone.style.visibility = 'hidden';
    clone.style.display = 'block';
    clone.style.left = submenu.getBoundingClientRect().left + 'px';
    clone.style.top = submenu.getBoundingClientRect().top + 'px';
    document.body.appendChild(clone);

    const rect = clone.getBoundingClientRect();
    const buffer = 50;
    const overflowsRight = (rect.right + buffer) > window.innerWidth || (rect.right - buffer) < 0;

    document.body.removeChild(clone);

    if (overflowsRight) {
      submenu.classList.add('navmenu-submenu-left');
    } else {
      submenu.classList.remove('navmenu-submenu-left');
    }
  }
  
  parentItems.forEach(item => {
    const debouncedHandler = debounce(() => handleSubmenuPosition(item), 100);
    item.addEventListener('mouseenter', debouncedHandler);
  });
}); 